/****************************************************
 * Module Name:  SystemSalesModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import InvoiceReport from "../report/invoiceReport";
import logo from '../../images/pansuriya.jpg'
import Constants from "../../utility/constants";
import { Box, Tab, Tabs } from "@mui/material";
import DnkInvoiceReport from "./dnkInvoiceReport";

const SystemSalesModal = ({ show,
    handleClose, defaulttodate,
    loadedCustomers, defaultfromdate,
    defaultStatus, onHide
}) => {
    const [tabValue, setTabValue] = useState(0);
    const [activeTab, setActiveTab] = useState("Current");

    const handleTabChange = (event, newValue) => {
        setActiveTab(event.target.textContent);
        setTabValue(newValue);
    };

    return (
        <div>
            <Modal
                enforceFocus={false}
                show={show}
                onHide={handleClose}
                dialogClassName="max-modalSize-Tab"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;
                        Invoice Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Box sx={{
                        width: '100%',
                        bgcolor: 'background.paper',
                        "& .MuiTabs-indicator": {
                            height: "3px",
                            bottom: "5px",
                        },
                        "& .MuiTabs-flexContainer": {
                            marginLeft: "15px",
                            marginTop: "1px"
                        }
                    }}>
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                        >
                            <Tab label="Current" />
                            <Tab label="DNK" />
                        </Tabs>
                    </Box>
                    {activeTab === "Current" ?
                        (< InvoiceReport
                            loadedCustomers={loadedCustomers}
                            defaultfromdate={defaultfromdate}
                            defaulttodate={defaulttodate}
                            defaultStatus={defaultStatus}
                            fromOtherComponent={true}
                            heightFromOtherComponent={"66vh"}
                        />) : <DnkInvoiceReport
                            loadedCustomers={loadedCustomers}
                            defaultfromdate={defaultfromdate}
                            defaulttodate={defaulttodate}
                        />}

                </Modal.Body>
            </Modal>
        </div >
    );
};
export default SystemSalesModal;